module.exports = __webpack_public_path__ + "static/media/slide0Active.5a97f9c0.png";